/**
 * ResponsavelHistoricoSms
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {Motorista} from '@/model/resource/Motorista'
import {TypeSms} from '@/model/resource/TypeSms'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelHistoricoSmsCollection} from '@/model/collection/ResponsavelHistoricoSmsCollection'

/* TODO: review generated class */
export class ResponsavelHistoricoSms extends Resource {
  idHistoricoPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  @ResponseSerialize(TypeSms)
  typeSms: TypeSms | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  nomeDestinatario: string | null = null
  mensagem: string | null = null
  dataEnvio: string | null = null

  nfe: string | null = null
  telefone: string | null = null
  idTypeFk: number | null = null

  get $id() {
    return this.idHistoricoPk
  }
  set $id(val) {
    this.idHistoricoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Lists the instances of ResponsavelHistoricoSms
   */
  static async listResponsavelHistoricoSms(params: any) {
    return await Request.get(`/admin/responsavel-historico-sms`, {params})
      .name('listResponsavelHistoricoSms')
      .as(ResponsavelHistoricoSmsCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelHistoricoSms. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelHistoricoSms() {
    return await Request.post(`/admin/responsavel-historico-sms`, this)
      .name('persistResponsavelHistoricoSms')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelHistoricoSms to use it in a CSV file
   */
  static async listCsvResponsavelHistoricoSms(params: any) {
    return await Request.get(`/admin/responsavel-historico-sms/csv`, {params})
      .name('listCsvResponsavelHistoricoSms')
      .as(ResponsavelHistoricoSmsCollection)
      .getData()
  }

  /**
   * Gets a instance of a given ID of ResponsavelHistoricoSms
   */
  async getResponsavelHistoricoSms(id: number) {
    return await Request.get(`/admin/responsavel-historico-sms/${id}`)
      .name('getResponsavelHistoricoSms')
      .as(this)
      .getData()
  }
}
